import React, { useEffect, useState } from "react";
import "./ChanelReplays.scss";

import ReplayPreview from "./ReplayPreview";
import ChanelReplaysSensor from "../chanel/ChanelReplaysSensor";
import ChanelFilters from "./ChanelFilters";
import NoResults from "./NoResults";

function ChanelReplays({
  data,
  params,
  startUrl,
  queryUrl,
  location,
  onDataUpdated = () => {}
}) {
  const [loaded, setLoaded] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    //FETCH HAND DETAILS
    //console.log("chanelReplays effect");
    setReady(false);
    setLoaded(false);
    let timer = setTimeout(() => {
      setLoaded(true);
    }, 100);
    let sensorTimer = setTimeout(() => {
      setReady(true);
    }, 1000);

    //FETCH HAND DETAILS
    return () => {
      //console.log("chanelReplays done");
      clearTimeout(timer);
      clearTimeout(sensorTimer);
    };
  }, [data, location.search]);

  if (data !== null) {
    return (
      <div
        className={
          "chanel-sections-container d-flex flex-column " +
          (loaded ? "loaded" : "")
        }
      >
        <ChanelFilters startUrl={startUrl} filterValues={data}></ChanelFilters>
        <div className="chanel-replays list d-flex flex-row">
          {data.last.map((hand, index) => {
            return <ReplayPreview key={hand.id} hand={hand}></ReplayPreview>;
          })}
          {data.last.length === 0 ? <NoResults></NoResults> : <></>}
          {data.last.length === 10 && ready ? (
            <ChanelReplaysSensor
              params={params}
              queryUrl={queryUrl}
              location={location}
              page={1}
              onDataUpdated={onDataUpdated}
            ></ChanelReplaysSensor>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}
export default ChanelReplays;
